import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Theme,
} from '@freighthub/silhouette-core'
import { Property } from 'csstype'
import { FC, useState } from 'react'
import { useI18n } from 'utils/localisation'

import { DOCUMENT_ACTION_TYPE, DocumentActionButton } from './DocumentActionButton'

export const testIds = {
  openButton: 'document_preview-open-button',
  dialog: 'document_preview-dialog',
  loader: 'document_preview-loader',
  frame: 'document_preview-frame',
}

const useStyles = makeStyles((_: Theme) => ({
  dialogContent: {
    position: 'relative' as Property.Position,
    padding: 0,
    display: 'flex',
    borderBottomWidth: 0,
  },
  containerPaper: {
    height: '100vh',
    minWidth: '95vw',
  },
  loaderContainer: {
    position: 'absolute' as Property.Position,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  previewFrame: {
    flexGrow: 1,
    border: 0,
  },
}))

interface DocumentPreviewProps {
  documentSource: string
  onPreview?: () => void
  onPreviewClose?: () => void
}
export const getPreviewUrl = (documentDownloadUrl: string) => {
  return documentDownloadUrl.replace(/\?jwt=/, '/preview$&')
}
export const DocumentPreview: FC<DocumentPreviewProps> = ({ documentSource, onPreview, onPreviewClose, ...other }) => {
  const { translate } = useI18n()
  const classes = useStyles({})
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(true)

  const handleClickPreview = () => {
    if (onPreview) {
      onPreview()
    }
    setOpen(true)
  }
  const handleClickClose = () => {
    if (onPreviewClose) {
      onPreviewClose()
    }

    setOpen(false)
    setLoading(true)
  }
  const handleLoadDocument = () => setLoading(false)

  return (
    <>
      <DocumentActionButton
        title={translate('document_preview-icon-tooltip')}
        actionType={DOCUMENT_ACTION_TYPE.PREVIEW}
        onClick={handleClickPreview}
        data-testid={testIds.openButton}
        {...other}
      />
      <Dialog
        open={open}
        onClose={handleClickClose}
        data-testid={testIds.dialog}
        classes={{ paper: classes.containerPaper }}
      >
        <DialogTitle onClose={handleClickClose} showClose>
          {translate('document_preview-dialog-title')}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {loading && (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              className={classes.loaderContainer}
              data-testid={testIds.loader}
            >
              <CircularProgress />
            </Grid>
          )}
          <iframe
            src={documentSource}
            onLoad={handleLoadDocument}
            className={classes.previewFrame}
            data-testid={testIds.frame}
            title="document-preview"
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
